import React from 'react'

type ReportPageShellProps = {
  title: string
  children: React.ReactNode
}

const ReportPageShell = ({ title, children }: ReportPageShellProps) => {
  return (
    <div className='card'>
      <div className='card-header'>
        <h4 className='card-title'>{title}</h4>
      </div>
      <div className='card-body'>
        <div className='report-form'>{children}</div>
      </div>
    </div>
  )
}

export default ReportPageShell
